<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ modal_title }}</p>
      <span
        class="modal-card-head-icon icon-x"
        @click="
          () => {
            setOpen(false);
            setItem(null);
          }
        "
      ></span>
    </header>
    <section class="modal-card-body">
      <b-field label="Title">
        <b-input type="text" v-model="title" placeholder="Title" required>
        </b-input>
      </b-field>

      <b-field label="Description">
        <b-input
          maxlength="500"
          type="textarea"
          v-model="description"
          placeholder="Description"
          required
          rows="3"
        >
        </b-input>
      </b-field>

      <b-field label="Categories">
        <b-taginput
          v-model="selectedCategories"
          :data="filteredCategories"
          rounded
          open-on-focus
          autocomplete
          type="is-categories"
          field="name"
          placeholder="Add a Category"
          @typing="getFilteredCategories"
          @remove="getFilteredCategories"
          @focus="getFilteredCategories"
        >
        </b-taginput>
      </b-field>

      <b-field label="Casting">
        <b-taginput
          v-model="casting"
          autocomplete
          :data="filteredCastings"
          allow-new
          open-on-focus
          @typing="getFilteredCastings"
          @remove="getUpdatedCastings"
          @focus="getUpdatedCastings"
          ellipsis
          rounded
          type="is-casting"
          placeholder="Add a tag"
          aria-close-label="Delete this tag"
        ></b-taginput>
      </b-field>

      <b-field label="Hashtags">
        <b-taginput
          id="custom-taginput"
          v-model="hashtags"
          autocomplete
          :data="filteredHashtags"
          allow-new
          open-on-focus
          @typing="getFilteredHashtags"
          @remove="getUpdatedHashtags"
          @focus="getUpdatedHashtags"
          ellipsis
          rounded
          type="is-hashtags"
          placeholder="Add a tag"
          aria-close-label="Delete this tag"
        ></b-taginput>
      </b-field>

      <div class="columns" v-if="media_hosts">
        <div class="column">
          <b-field label="Media">
            <b-radio-button
              v-for="media_host in media_hosts"
              :key="media_host.id"
              v-model="media_host_id"
              :native-value="media_host.id"
              type="is-sorint is-light is-outlined"
            >
              <span>{{ media_host.name }}</span>
            </b-radio-button>
          </b-field>

          <b-field label="Video type">
            <b-switch
              v-model="is_live"
              type="is-success"
              @input="handleLiveToggle"
            >
              {{ is_live ? "Live Video" : "Regular Video" }}
            </b-switch>
          </b-field>

          <b-field label="Code">
            <b-input type="text" v-model="code" placeholder="Code" required>
            </b-input>
          </b-field>
        </div>
        <div class="column">
          <div
            style="display: flex; justify-content: center"
            v-if="media_hosts"
          >
            <b-field custom-class="preview-field">
              <template #label>
                <div class="preview-label">
                  <span>Preview</span>
                  <b-tag
                    v-if="is_live"
                    type="is-danger"
                    size="is-small"
                    class="preview-live-tag"
                  >
                    LIVE
                  </b-tag>
                </div>
              </template>
              <iframe
                :src="`${selected_media_host.embed_prefix}${code}${
                  is_live ? '?autoplay=1&rel=0' : ''
                }`"
              ></iframe>
            </b-field>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <div style="margin-left: auto; margin-right: 0">
        <button-icon
          v-if="item"
          @click="confirmDeleteVideo()"
          text="Delete video"
          iconClass="icon-x"
          iconSide="right"
          cssBackgroundColor="#FFFFFF"
          cssBorderRadius="12px"
          cssPadding="12px 16px"
          cssBorder="1px solid #E8EBED"
          cssTextColor="black"
        />
        <button-icon
          :disabled="!(this.title && this.description && this.code && this.media_host_id)"
          v-if="item"
          @click="update(video)"
          text="Update video"
          iconClass="icon-send"
          iconSide="right"
          cssBackgroundColor="#F17023"
          cssBorderRadius="12px"
          cssPadding="12px 16px"
          cssBorder="1px solid #E8EBED"
          cssTextColor="white"
        />
        <button-icon
          :disabled="!(this.title && this.description && this.code && this.media_host_id)"
          v-if="!item"
          @click="create(video)"
          text="Create video"
          iconClass="icon-send"
          iconSide="right"
          cssBackgroundColor="#F17023"
          cssBorderRadius="12px"
          cssPadding="12px 16px"
          cssBorder="1px solid #E8EBED"
          cssTextColor="white"
        />
      </div>
    </footer>
  </div>
</template>

<script>
import utils from "@/utils/utils";
import { mapActions, mapGetters } from "vuex";
import ButtonIcon from "@/components/shared/ButtonIcon.vue";
import DOMPurify from "dompurify";
import { getKeycloak } from "@/services/keycloakService";
export default {
  name: "VideoModal",
  components: {
    ButtonIcon,
  },
  data() {
    return {
      id: null,
      title: "",
      description: "",
      selectedCategories: [],
      casting: [],
      code: "",
      hashtags: [],
      media_host_id: "",
      created: null,
      filteredHashtags: [],
      filteredCastings: [],
      filteredCategories: [],
      promotional: false,
      is_live: false,
    };
  },
  async mounted() {
    const promise1 = this.fetchCategories();
    const promise2 = this.fetchMediaHosts();
    const promise3 = this.fetchHashtags();
    const promise4 = this.fetchCastings();
    await Promise.all([promise1, promise2, promise3, promise4]);
    if (!this.media_host_id && this.media_hosts?.length) {
      this.media_host_id = this.media_hosts[0].id;
    }
  },
  created() {
    if (this.item) {
      this.id = this.item.id;
      this.title = this.item.title;
      this.description = this.item.description;
      this.selectedCategories = this.item.categories;
      this.casting = this.item.casting;
      this.code = this.item.code;
      this.hashtags = this.item.hashtags;
      this.media_host_id = this.item.media_host_id;
      this.created = this.item.created;
      this.promotional = this.item.promotional;
      this.is_live = this.item.is_live || false;
    }
  },
  computed: {
    ...mapGetters("categories", { video_categories: "categories" }),
    ...mapGetters("modal", ["item", "episode_number"]),
    ...mapGetters("mediaHosts", ["media_hosts"]),
    ...mapGetters("admin", ["impersonated_user"]),
    ...mapGetters("videos", {
      video_hashtags: "hashtags",
      video_castings: "castings",
    }),
    ...mapGetters("seasons", ["selected_season"]),
    embedUrl() {
      if (!this.code) return "";
      const cleanId = this.code.trim();
      const embedUrl = `${this.selected_media_host.embed_prefix}${cleanId}`;

      // if is live add parameters
      if (this.is_live) {
        return `${embedUrl}?autoplay=1&rel=0`;
      }

      return embedUrl;
    },
    video() {
      const keycloak = getKeycloak();
      const username = keycloak?.tokenParsed?.preferred_username;

      return {
        id: this.id || null,
        title: this.title,
        description: this.description,
        categories: this.selectedCategories.map((category) => category.id),
        casting: this.arrayToString(this.casting),
        code: this.code,
        hashtags: this.arrayToString(this.hashtags),
        media_host_id: this.media_host_id,
        created: this.created,
        owner_username: utils.isAdmin() ? this.impersonated_user : username,
        promotional: this.promotional,
        is_live: this.is_live,
      };
    },
    modal_title() {
      return this.item ? `Update Video "${this.title}"` : "Create New Video";
    },
    selected_media_host() {
      return (
        this.media_hosts.find((media) => media.id === this.media_host_id) ||
        this.media_hosts[0]
      );
    },
  },
  methods: {
    ...mapActions("categories", ["fetchCategories"]),
    ...mapActions("videos", [
      "createVideo",
      "updateVideo",
      "deleteVideo",
      "fetchHashtags",
      "fetchCastings",
    ]),
    ...mapActions("episodes", ["createEpisode"]),
    ...mapActions("modal", ["setOpen", "setItem"]),
    ...mapActions("mediaHosts", ["fetchMediaHosts"]),
    confirmDeleteVideo() {
      const sanitizedTitle = DOMPurify.sanitize(this.title);
      this.$buefy.dialog.confirm({
        title: "Deleting Video",
        message: `Are you sure you want to <b>delete</b> the video "${sanitizedTitle}"? </br>This action cannot be undone.`,
        confirmText: "Delete Video",
        type: "is-danger",
        onConfirm: () =>
          this.deleteVideo(this.video.id)
            .then(() => this.$emit("closeModal"))
            .catch((error) => {
              this.$buefy.toast.open({
                duration: 10000,
                message: `Error deleting video: ${
                  error?.response?.data === "ERR_VIDEO_HAS_EPISODES"
                    ? "Video is linked to an episode"
                    : error?.response?.data
                }`,
                type: "is-danger",
              });
            }),
      });
    },
    update() {
      if (!(this.title && this.description && this.code && this.media_host_id)) return;

      const videoPayload = this.video;

      this.updateVideo(videoPayload)
        .then(() => {
          this.$emit("closeModal");
        })
        .catch((error) => {
          console.error("Update failed:", error);
          this.$buefy.toast.open({
            message: "Failed to update video",
            type: "is-danger",
          });
        });
    },
    create() {
      if (!(this.title && this.description && this.code && this.media_host_id)) return;
      this.createVideo(this.video)
        .then((newVideo) => {
          if (!newVideo?.id) {
            throw new Error("The created video could not be loaded");
          }
          this.$emit("switchModal", "VideoCropper", newVideo);
          if (this.episode_number) {
            this.createEpisode({
              id: null,
              episode: Number(this.episode_number),
              seasonid: this.selected_season.id,
              videoid: newVideo.id,
            });
          }
        })
        .catch((error) => {
          this.$buefy.toast.open({
            message: `Failed to create video: ${error.message}`,
            type: "is-danger",
          });
        });
    },
    arrayToString(array) {
      return array.join("#");
    },
    getFilteredCategories() {
      this.filteredCategories = this.video_categories?.filter((el) => {
        return !this.selectedCategories.map((c) => c.id).includes(el.id);
      });
    },
    getFilteredHashtags(text) {
      this.filteredHashtags = this.video_hashtags
        ?.filter((el) => {
          return !this.hashtags.includes(el);
        })
        .filter((hashtag) => {
          return hashtag
            .toString()
            .toLowerCase()
            .includes(text.toString().toLowerCase());
        });
      if (text && text.length > 0) this.filteredHashtags.unshift(text);
    },
    getFilteredCastings(text) {
      this.filteredCastings = this.video_castings
        ?.filter((el) => {
          return !this.casting.includes(el);
        })
        .filter((casting) => {
          return casting
            .toString()
            .toLowerCase()
            .includes(text.toString().toLowerCase());
        });
      if (text && text.length > 0) this.filteredCastings.unshift(text);
    },
    getUpdatedHashtags() {
      this.filteredHashtags = this.video_hashtags?.filter((el) => {
        return !this.hashtags.includes(el);
      });
    },
    getUpdatedCastings() {
      this.filteredCastings = this.video_castings?.filter((el) => {
        return !this.casting.includes(el);
      });
    },
    handleLiveToggle(value) {
      this.is_live = value;
      if (value) {
        // Add tag #liveVideo
        if (!this.hashtags.includes("liveVideo")) {
          this.hashtags.push("liveVideo");
        }
      } else {
        // Remove tag #liveVideo
        const index = this.hashtags.indexOf("liveVideo");
        if (index > -1) {
          this.hashtags.splice(index, 1);
        }
      }
    },
  },
  watch: {
    video_categories() {
      this.filteredCategories = this.video_categories;
    },
    video_hashtags() {
      this.filteredHashtags = this.video_hashtags;
    },
    video_castings() {
      this.filteredCastings = this.video_castings;
    },
  },
};
</script>

<style scoped>
.preview-label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.preview-live-tag {
  margin-top: -2px;
}

:deep(.preview-field .label) {
  margin-bottom: 0.5em;
}
</style>
